import React, { Component }     from "react";
import { FontAwesomeIcon }           from '@fortawesome/react-fontawesome'
import { Button, PageHeader, DropdownButton, FormGroup, InputGroup, FormControl, OverlayTrigger, Tooltip, MenuItem, ListGroup, ListGroupItem, PanelGroup, Panel } from "react-bootstrap";
import { invokeApig }           from '../../libs/awsLib';
import FooterLoadingBar         from "../../components/utils/FooterLoadingBar";
import ModalSendProgram         from "../../components/modal/ModalSendProgram";
import ModalCreateFolder        from "../../components/modal/ModalCreateFolder";
import ModalMoveProgramToFolder from "../../components/modal/ModalMoveProgramToFolder";
import ModalProgramSummary      from "../../components/modal/ModalProgramSummary";
import ModalAlert               from "../../components/modal/ModalAlert";
import { Colors }               from "../../utils/Colors";
import { TS_LU, TS_ASP }        from "../../utils/StaticIds";
import RenderLander             from "../../components/utils/RenderLander";
import { invokeGetProgramList,
         invokeGetClientProgramList,
         invokeDuplicateProgram,
         invokeDeleteProgram,
         invokeDeleteProgramFolder,
         invokeGetSearchProgramsList,
         invokeCheckIfProgramDuplicated
       } from "../../utils/AwsInvoke";
import uniqueId                 from 'lodash/uniqueId';
import { handleGoToURL}         from "../../utils/URL";
import "../../css/ProgramList.css";

// uuidv1() = timestamp | uuidv4() = rnadom
const uuidv1 = require('uuid/v1');
var global_timer_ctr = 0;

export default class ProgramList extends Component {
    constructor(props) {
        super(props);

        var company_id = this.props.globalCompanyId;
        var search_term = `${this.props.match.params.search_term}`;
        if(search_term === "&" || search_term === "undefined") search_term = "";

        this.state = {
          isLoading: true,
          isPricedTemplate: false,
          searchTerm: search_term,
          loadingTime: null, // count the number of seconds
          footerBarAction: "none",
          showLoadingBar: "none",
          showModalCreateFolder: false,
          showModalMoveProgram: false,
          showModalProgramSummary: false,
          showModalSendProgram: false,
          modalAlertTitleText: "",
          modalAlertBodyText: "",
          loadingData: "Loading data ...",
          exerciseId: "",

          modalAlertTitleText: "",
          modalAlertBodyText:  "",
          showModalAlert:      false, // true | false
          alertObject:         {},
          alertAction:         "",

          companyId: company_id,
          clientId: `${this.props.match.params.client_id}`,
          clientName: `${this.props.match.params.client_name}`,
          programs: []
        };
    }

    componentDidMount() {
        var client_id = this.state.clientId;

        this.setState({
            showLoadingBar: "inline"
        })

        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            if(client_id != "undefined")
                this.getClientProgramList();
            else
                this.getProgramList(""); // "" = search all

        } catch (e) {
            alert(e);
        }
    }

    getProgramList = async (search_term) => {

        this.setState({
            loadingData: "Loading Programs ...",
        });

        const results = await invokeGetProgramList(search_term);

        if(results) {
            this.setState({
                programs: results.programs,
                folders: results.folders,
                program_ids: results.program_ids,
                program_ids_no_dir: results.program_ids_no_dir, //.id || .name
                isLoading: false,
                showLoadingBar: "none", //"none"
            });
        }
    }

    getClientProgramList = async event => {
        var client_id = this.state.clientId;

        this.setState({
            loadingData: "Loading Programs ...",
        });

        const results = await invokeGetClientProgramList(client_id);

        if(results) {

            this.setState({
                programs: results.programs,
                folders: "",
                program_ids: results.program_ids,
                program_ids_no_dir: results.program_ids_no_dir, //.id || .name
                isLoading: false,
                showLoadingBar: "none"
            });
        }
    }

    alertFunction = (alert_action, client_id, program_id, folder_id) => {

        if(alert_action === "deleteProgram")
            this.deleteProgram(client_id, program_id);
        else if(alert_action === "deleteFolder")
            this.deleteProgramFolder(folder_id)
    }

    async handleDeleteProgram (event, program_id) {
        // tmp remove: this.setState({ showLoadingBar: "inline" });

        event.preventDefault();
        var client_id    = this.state.clientId;
        var alert_object = { client_id: client_id, program_id: program_id }

        this.setState({
            modalAlertTitleText: "Delete Program Confirmation",
            modalAlertBodyText:  "Are you sure you want to delete this program?",
            showModalAlert:      true,
            alertObject:         alert_object, // used to delete programs; not req'd
            alertAction:         "deleteProgram"
        })

        /*const confirmed = window.confirm(
            "Are you sure you want to delete this program?"
        );

        if (!confirmed) {
            this.setState({
                isLoading: false,
                showLoadingBar: "none"
            });
            return;
        }*/
    }

    deleteProgram = async (client_id, program_id) => {
            this.setState({
                loadingData: "Deleting Program ...",
            });

            var results = await invokeDeleteProgram(program_id);

            if(results.status) {
                this.setState({ showModalAlert: false });

                if(client_id != "undefined") await this.getClientProgramList();
                    else await this.getProgramList(""); // "": search all

                this.setState({
                    modalAlertTitleText: "Delete Program",
                    modalAlertBodyText:  "The program has been deleted",
                    showModalAlert:      true,
                    alertObject:         "",
                    alertAction:         "",
                    footerBarAction:     "none",
                })
            }
    }

    componentDidCatch(error, info) {
        // Something happened to one of my children.
        // Add error to state
        console.log("componentDidCatch Error: " + error);
    }

    handleDuplicateProgram = async (curr_program_id, program_name, client_id, is_template, send_to_diff_trainer, client_name, is_priced_template) => {
        /*const confirmed = window.confirm("Are you sure you want to duplicate this program?");
        if (!confirmed) return;*/

        var member_name;
        if(client_name == null) member_name = ""
            else member_name = client_name + "'s";

        var new_program_id = uuidv1();
        var msg_text       = "copied to " + member_name + " \"Templates.\" ";
        var loading_data   = "Copying Program ...";
        var text           = "program";
        var action         = "duplicateProgram"
        if(!is_template) {
            text = "template";
            msg_text = "sent to " + client_name + ".";
            loading_data = "Sending Program to Member ...";
        }

        this.setState({
            loadingTime: 1,
            loadingData: loading_data,
            showLoadingBar: "inline",
            newProgramId: new_program_id,
            startTimer: true,
            footerBarAction: "programList_duplicateProgram"
        });

        // If ASP wants to duplicate a send template, do not capture the date in the template priced db table;
        // otherwise it requires a user id, which isn't available for duplicated templates (since you're not sending to anyone)
        if(is_priced_template && client_id === 0) {
            //console.log("ADMIN is duplicating a send template since the client_id = 0; a template is not being sent since there's no client id.");
            action = "duplicatePricedTemplateFromAdmin"; // allow admins to duplicate priced template
        }

        /*var today = new Date();
        var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        console.log("++++++++++++++++++ Begin time: " + time );*/

        var results  = await invokeDuplicateProgram(curr_program_id, new_program_id, program_name, client_id, is_template, send_to_diff_trainer, is_priced_template, action);
        var tmp_url_str = this.props.location.pathname;

        /* var today2 = new Date();
        var time2 = today2.getHours() + ":" + today2.getMinutes() + ":" + today2.getSeconds();
        console.log("++++++++++++++++++ End time: " + time2 ); */

        if(results.status) {
            this.setState({
                loadingTime: null,
                startTimer:false,      // stop timer
                footerBarAction: "none", // reset footer action
                isLoading: false,
                showLoadingBar: "none"

            }, function() {
                //this.props.changeProcessingHeader("hideProcessingMessage", "");
                this.showModal(text, msg_text, client_id, tmp_url_str);
            })
        }
    }

    ////  If there's an error because the new program is too big and taking too long (> 30 secs),
    ////  a timer is set to see if the program has finished duplicating;
    // console.log("Duplicate Program: Check db if the program is complete yet. Timeout after 30 more seconds.");
    ///  AFTER 20 SECONDS, CHECK IF PROGRAM HAS BEEN DUPLICATED  ////

    checkIfNewProgramWasDuped = async (new_program_id, start_timer) => {

        ////  DUPLICATE A TIMER OBJECT FOR A NEW PROCESS  ///
        //var task = this.testTimer("v1");
        //var task2 = this.testTimer("v2");

        /****

        PROBLEM: TWO PROGRAMS WON'T DUPLICATE AT SAME TIME
        Is node multi-threaded? Or Lambda have congrstion problems with multiple processes

        ****/

        this.timerCheckProcessCompleted(new_program_id, start_timer);
    }

    testTimer = async (text) => {
        /*var ct_secs  = 0;
        var    timer = setInterval(beginTimer, 1000);
        var that  = this;

        function beginTimer() {
            console.log(text + ". counting secs: "+ ct_secs++);
            if(ct_secs >= 3) {
                clearInterval(timer)
                // check database every 2-3 secs to see if the lambda process finished //
                that.timerCheckProcessCompleted();
            }
        }*/

    }

    timerCheckProcessCompleted = async (new_program_id, start_timer) => {
            //var start_timer    = this.state.startTimer;
            var results        = await invokeCheckIfProgramDuplicated(new_program_id);
            var timer;
            var manual_stop_timer = false;

            console.log("Begin TimerCheckProcessCompleted new_program_id: " + new_program_id);

            // Max global ctr out at 1.5 minutes; each ctr is 3 secs //
            /*if(global_timer_ctr >= 30) {
                clearInterval(timer);
                manual_stop_timer = true; // stop timer from starting again
                this.setState({
                    loadingTime: null,
                    start_timer:false,      // stop timer
                    footerBarAction: "none", // reset footer action
                    isLoading: false,
                    showLoadingBar: "none"
                })
            }*/

            if(results[0] != undefined) {

                    if(results[0].uid === new_program_id) {
                        console.log("Stop timer for program id: " + new_program_id);
                        //this.showModal(text, msg_text, client_id, tmp_url_str);
                        var that    = this;
                        start_timer = false;  // stop timer for this instance
                        this.setState({
                            // reset loading time; this is req'd otherwise the checkIfNewProgramWasDupe()
                            // will continually loop and check the db tables
                            loadingTime: null,
                            footerBarAction: "none", // reset footer action so timer doesn't keep going
                        }, function() {
                            // Getting new program list must come after the loadingTime state is set //
                            global_timer_ctr = 0;
                            clearInterval(timer);
                            this.getProgramList("");
                        })
                    } else {
                        ////  Hide the popup while the task is processing in the backgrund  ////
                        this.clearProgressOverlay()
                    }
            } else if(start_timer && !manual_stop_timer) {
                    //console.log("---------- 2. BEGIN  * 3 SECOND  TIMER * --------");
                    global_timer_ctr++;
                    console.log("Global_ctr: " + global_timer_ctr);
                    ////  BEGIN TIMER & CHECK IF PROGRAM WAS DUPED AGAIN  ////
                    //var ct_secs  = 0;
                        timer = setInterval(beginTimer, 3000);
                    var that  = this;

                    function beginTimer() {
                        //ct_secs++
                        //console.log("2. counting secs: "+ ct_secs);
                        console.log("Timer new_program_id: " + new_program_id);
                        //if(ct_secs >= 3) {
                            clearInterval(timer)
                            // check database every 2-3 secs to see if the lambda process finished //
                            that.timerCheckProcessCompleted(new_program_id, start_timer);
                        //}
                    }
            }
    }

    showModal = (text, msg_text, client_id, tmp_url_str) => {
        this.setState({
            isLoading: false,
            showLoadingBar: "none",
            loadingTime: null,
            modalAlertTitleText: "Templates & Programs",
            modalAlertBodyText:  "The " + text + " has been "+msg_text,
            showModalAlert:      true,
            alertObject:         "",
            alertAction:         ""
        })

        //if(!is_template) {
        if(client_id != "undefined" && client_id != 0 || tmp_url_str === "/programs/list") {
            this.getProgramList("");
        } else {
            this.props.history.push("/programs/list");
        }
    }

    showTaskManagerHeader () {
//        this.props.changeProcessingHeader("processMessage", "loading_data");
    }

    clearProgressOverlay = () => {
        this.setState({
            isLoading: false,
            showLoadingBar: "none",
            footerBarAction: "none", // reset footer action so timer doesn't keep going
        })
    }

    deleteProgram(program_id) {
        return invokeApig({
          path: '/programs/'+program_id,
          method: "DELETE"
        });
    }

    getProgramsInFolder (folder_id, program_ids, admin_permission) {
        var client_id = "undefined";
        return [{}].concat(program_ids).map(
                (program, i) =>
                  folder_id === program.folder_id ?
                         <div key= {uniqueId()} style={{position:"relative", top:-15, padding:10, borderBottom: "1px solid #ccc"}}>
                             { this.getSingleProgramRow(client_id, program, program.program_id, program.date_modified, program.is_priced_template, i, admin_permission) }
                         </div>
                : "" // return empty string
            )
    }

    deleteProgramFolder = async (folder_id) => {

            this.setState({
                //showModalAlert: false,
                loadingData: "Deleting Program Folder ...",
            });

            var results = await invokeDeleteProgramFolder(folder_id);
            console.log("results.status: " + results.status);

            if(results.status) {

                this.setState({
                    isLoading: false,
                    showLoadingBar: "none",

                    modalAlertTitleText: "", //Templates",
                    modalAlertBodyText:  "", //Your template folder was deleted.",
                    showModalAlert:      false,
                    alertObject:         "",
                    alertAction:         ""
                }, function(){
                    this.getProgramList(""); // "": search all
                })
            }

    }

    handleDeleteProgramFolder = async (folder_id) => {
        // tmp remove: this.setState({ showLoadingBar: "inline" });
        // don;t use event.preventDefault();
        var alert_object = { folder_id: folder_id }

        this.setState({
            modalAlertTitleText: "Delete Folder Confirmation",
            modalAlertBodyText:  "Are you sure you want to delete this folder and all its programs?",
            showModalAlert:      true,
            alertObject:         alert_object,
            alertAction:         "deleteFolder"
        })
    }

    renderFoldersList (folders, program_ids) {
        if(folders != undefined) {
            var admin_permission  = false;
            var globalAdminUserId = this.getAdminUserId()

            if(globalAdminUserId === TS_LU || globalAdminUserId === TS_ASP) {
                admin_permission = true;
            }

            return [{}].concat(folders).map(
                (folder, key) => {
                      if(key !== 0) {
                          var program = this.getProgramsInFolder(folder.uid, program_ids, admin_permission); // retrieve programs in folder

                         /* Commented out functionality where only programs in a folder are shown ... but is this desired behavior?
                         // what if the user wants to see all folders even if there are no programs in them? i.e. maybe he wants to move his program?

                          var filtered = program.filter( el => el != "");
                          var lgth = filtered.length; // how many programs are in the folder?
                          // Only show folders with programs in them ?
                          if(lgth > 0) {*/
                                  return (<Panel
                                              key         = {uniqueId()}
                                              collapsible
                                              //defaultExpanded
                                              header      = {<span>
                                                                  <span className="glyphicon glyphicon-folder-open"/>
                                                                  &nbsp;
                                                                  <span style={{textDecoration: "none"}}>
                                                                    &nbsp; {folder.name}
                                                                  </span>
                                                                  <span style={{float:"right", textDecoration: "none"}}>
                                                                      <span className="glyphicon glyphicon-remove deleteProgramFolderGlyphIcon"
                                                                            onClick={this.handleDeleteProgramFolder.bind(this, folder.uid)}
                                                                      />
                                                                  </span>
                                                              </span>}
                                              eventKey    = {"key"}
                                              className   = "aPanelLink"
                                              style       = {{display:"inline-block", height:40, width: "100%", border: "0px solid red"}}
                                          >
                                                  { program }
                                          </Panel>
                                      )
                            // } else return; //
                      }
                        else
                            null
                 }
            ) // end map
        } // end if
    }


    getAdminUserId = () => {
       var globalAdminUserId = localStorage.getItem('globalAdminUserId');
       return globalAdminUserId;
    }

    buildSingleRow(client_id, i, pid, name, date_created, is_priced_template, admin_permission) {
        // Below is used for future function
        var convert_to_perm_template = <span>
                                            <MenuItem divider />
                                            <MenuItem onClick={(e) => this.handleDeleteProgram(e, pid)}
                                                      style={{float: "right", zIndex:"10000 !important"}}>
                                                <span className = "glyphicon glyphicon-trash"/> &nbsp;
                                                Convert Template
                                            </MenuItem>
                                            <MenuItem divider />
                                       </span>
        // Clear out menu item
        convert_to_perm_template = "";

        // If template is purchaseable, do not allow any users but ASP to duplicate it; can only be sent to a member //
        var disable_btn = false; // 4/21 - comment out temporarily true;
        var tooltip     = "Copy Template"

        if(is_priced_template) {
            disable_btn = false; // normally true
            tooltip     = "It costs $1 - $4 to send a priced template."; //Sorry, you can't copy paid templates.";
        }

        // if jack||kevin, let us duplicate "priced templates"
        // 4/21 - if(admin_permission) // commented out 4/21
        //     disable_btn = false;

        var priced_button_class = "glyphicon glyphicon-duplicate grayBtnView programListButtons1";
        if(is_priced_template && admin_permission) {
            tooltip = "Send a Priced Template."
            priced_button_class = "glyphicon glyphicon-usd grayBtnView programListButtons1";
        }

        var template_buttons = <span className="programRowHomeBtns programListDropdownButtons">

                                           <OverlayTrigger
                                                   key       = {uniqueId()} /*"top"*/
                                                   placement = "top"
                                                   overlay={
                                                     <Tooltip id = "top" >
                                                       Assign Program to Client
                                                     </Tooltip>
                                                   }
                                           >
                                                   <Button id        = {i}
                                                           onClick   = {() => this.handleShareProgram(pid, name, is_priced_template)} // uses this.handleDuplicateProgra
                                                           style     = {{paddingTop: 10, paddingBottom:6, paddingLeft: 17, paddingRight: 17}}
                                                           className = "grayBtnView programListButtons1">
                                                           <FontAwesomeIcon icon="share" style={{fontSize:20}} className="" />
                                                   </Button>
                                           </OverlayTrigger>
                                           &nbsp; &nbsp;
                                           <OverlayTrigger
                                                  key       = "top"
                                                  placement = "top"
                                                  overlay={
                                                    <Tooltip id = "top">
                                                      { tooltip }
                                                    </Tooltip>
                                                  }
                                           >
                                                   <Button id        = {i}
                                                           disabled  = {disable_btn}
                                                           onClick   = {() => this.handleDuplicateProgram(pid, "Copy of "+name, 0, true, false, null, is_priced_template)}
                                                           className = {priced_button_class}>
                                                   </Button>
                                           </OverlayTrigger>
                                           &nbsp; &nbsp;
                                           <DropdownButton bsSize="large"
                                                           pullRight
                                                           /*onSelect={(event) => this.onSelect(event)}*/
                                                            title     = "..."
                                                            style     = {{float: "right", zIndex:1}}
                                                            className = "programListDropdownFolder"
                                                            id        = "dropdown-size-large">
                                                   <MenuItem divider />
                                                   <MenuItem onClick   = {() => this.showModalProgramSummary(pid, is_priced_template, name)}>
                                                        <span className = "glyphicon glyphicon-list-alt"/> &nbsp;
                                                        Program Summary
                                                   </MenuItem>
                                                   <MenuItem divider />
                                                   <MenuItem onClick   = {() => this.showModalMoveProgram(pid)}>

                                                       <span className = "glyphicon glyphicon-move"/> &nbsp;
                                                       Move to Folder
                                                   </MenuItem>
                                                   { /*convert_to_perm_template*/ }
                                                   <MenuItem divider />
                                                   <MenuItem onClick={(e) => this.handleDeleteProgram(e, pid)}
                                                             //style={{float: "right", zIndex:"10000 !important"}}
                                                             >
                                                       <span className = "glyphicon glyphicon-trash"/> &nbsp;
                                                       Delete Program
                                                   </MenuItem>

                                             </DropdownButton>
                                 &nbsp;&nbsp;

                             </span>
        var is_template = true; // used to hide or show the Add Notes button in modal simple
        var client_name;

        if(client_id != "undefined" && client_id != 0) {
            client_name = this.state.clientName;
            is_template = "false"; // must add client_id so we can pass the client name onto the program so the breadcrumb link can show the member's full name
            template_buttons = <span className="programRowHomeBtns">

                                    <Button id        = {i}
                                            disabled  = {disable_btn}
                                            onClick   = {() => this.handleDuplicateProgram(pid, "Copy of "+name, 0, true, false, null, is_priced_template)}
                                            className = "grayBtnView programListButtons1"> { /*glyphicon glyphicon-duplicate */ }
                                            Copy as Template
                                    </Button> &nbsp;
                                    <Button id = {i}
                                            onClick = {(e) => this.handleDeleteProgram(e, pid)}
                                            className = "glyphicon glyphicon-trash grayBtnView programListButtons1">
                                    </Button>
                               </span>

        } else
            client_name = 0;

        /////   BEGIN: Is user coming from the Templates or Member Programs Section?   /////
        var tmp_url_str = this.props.location.pathname;
        var sub_str = tmp_url_str.match("/(.*)/");
        var section;
        var url = "programs";

        if(sub_str != null) section = sub_str[1].substr(0, sub_str[1].indexOf('/'));
        if(section === "client") url = "client";
        /////    END   /////

        if(client_id == "undefined") client_id = 0;

        var member_url = '/'+url+'/detail/'+pid+'/'+is_template+'/'+client_name+'/'+client_id;


        return    <div key={uniqueId()}
                       className="programRowHomeContainer-old"
                       style={{display:"inline-block", width:"100%", height: 55, /*zIndex:1,*/ position:"relative", top:0, left:0, border:"0px solid red", cursor:"pointer"}} /* */
                  >
                           <span href={member_url}
                                 onClick={this.handleProgramClick}
                                 className="programRowHome"
                                 style={{display:"inline-block", width:"100%", height: 55, zIndex:1, position:"relative", top:0, left:0, border:"0px solid red", cursor:"pointer"}}
                           >
                               <span className="programRowHomeTitle">
                                  {/*pid*/}{ name }
                               </span>
                               <span className="programRowHomeDate">
                                   {"Modified: " + new Date(date_created).toLocaleString([], {month: 'short', day:'2-digit', hour: '2-digit', minute:'2-digit'})}
                              </span>
                       </span>
                       { template_buttons }
                </div>
    }

    getSingleProgramRow(client_id, program, pid, date_mod, is_priced_template, i, admin_permission) {

        var name;

        //// Check if program doesn't have a title, if it does then keep the original name
        if(program == null) name - undefined;
            else name = program.name;

        //var date_mod = program.date_last_modified;
        //if(pid === undefined)   pid = program.program_id;
        if(name === undefined) name = program;

        return this.buildSingleRow(client_id, i, pid, name, date_mod, is_priced_template, admin_permission)
    }

    handleKeyPress = (target) => {
        // Allow user to hit "Enter" when using Search box //
         if(target.charCode === 13)
            this.searchExercises();
    }

    clearSearchField = () => {
        // RESET URL
        // this.props.history.replace("/programs/list/&")

        this.setState({
            searchTerm: "", // reset search term if resetting exerc list
        })
    }

    searchExercises = async (number_of_rows, sort_by) => {
            var search_term = this.state.searchTerm;

            if(this.searchInput != undefined) {
                search_term = this.searchInput.value;

                if(search_term.length === 0) search_term = "&";

                //this.props.history.replace("/exercise/listAll/"+search_term)

                //// RESET Search Textfield
                if(search_term === "&") {
                    this.setState({
                        searchTerm: "", // reset search term if resetting exerc list
                        searchMsg: ""   // clear search message
                    }, function () {
                        this.getProgramList(""); // "": search all
                    })
                    return
                }
            }

            this.getProgramList(search_term); // "": search all
    }

    renderProgramsList(client_id, programs) {

        if(programs != undefined) { //programs = {name:""};
        var admin_permission  = false;
        var globalAdminUserId = this.getAdminUserId()

        if(globalAdminUserId === TS_LU || globalAdminUserId === TS_ASP) {
            admin_permission = true;
        }

                var add_folder_btn;
                var search_bar;
                if(client_id === "undefined") {
                    add_folder_btn = <Button bsStyle = "default"
                                            style={{backgroundColor: Colors.medium_gray, color:"#fff"}}
                                            className = "btnFolderPosition pull-right"
                                            onClick = {() => this.showModalCreateFolder()}
                                     >
                                        <span className="glyphicon glyphicon-folder-open"></span> &nbsp; Add Folder
                                     </Button>

                    search_bar     = <div className="programListHeaderSearchBar">
                                        <span>
                                            <FormGroup>
                                               <InputGroup>
                                                 <FormControl key = {uniqueId()}
                                                              type="text"
                                                              placeholder=""
                                                              defaultValue={this.state.searchTerm}
                                                              inputRef={ref => { this.searchInput = ref; }}
                                                              onKeyPress={this.handleKeyPress}
                                                          />

                                                   <span className="glyphicon glyphicon-remove-circle searchInputClearBtn"
                                                         onClick={() => this.clearSearchField()}
                                                   />
                                                   <InputGroup.Button>
                                                        <Button style={{ display:"inline-block", height:"34px",backgroundColor: Colors.ok_button_bg, color:"white", borderRadiusInputTopRight: "5px" }}
                                                             onClick={() => this.searchExercises()}>
                                                             Search
                                                         </Button>
                                                   </InputGroup.Button>
                                               </InputGroup>
                                             </FormGroup>
                                         </span>
                                     </div>
                }

                return [{}].concat(programs.name).map(
                    (program, i) =>
                      i !== 0 ?
                             <div
                                 key={uniqueId()}
                                 className="programListSingleRow"
                                 //onClick={this.handleProgramClick}
                               >
                                  { this.getSingleProgramRow(client_id, program, programs.id[i-1], programs.date_mod[i-1], programs.is_priced_template[i-1], i, admin_permission) }
                              </div>
                        :
                            <span key={uniqueId()} >
                                { search_bar }
                                <div key={uniqueId()} className="newProgramHeader">
                                    <span>
                                        { add_folder_btn }
                                     </span>
                                 </div>

                              { i === 0 && Object.keys(programs.name).length < 1 ?
                                    <ListGroupItem style={{height:200}}>
                                        <br/>
                                    You currently have 0 programs in your main folder.
                                    </ListGroupItem>

                                : null }
                          </span>
                );
        } else {
            return <span key={1000} >

                        <ListGroupItem style={{height:400}}>
                            <br/>
                            You currently have 0 programs.
                        </ListGroupItem>
                   </span>
        }
    }

    handleShareProgram (program_id, orig_title, is_priced_template) {

        this.setState({
            programName: orig_title,
            showModalSendProgram: true,
            program_id: program_id,
            isPricedTemplate: is_priced_template
        })
    }

    showModalCreateFolder () {
        this.setState({
            showModalCreateFolder: true
        })
    }

    showModalMoveProgram = program_id => {
        this.setState({
            showModalMoveProgram: true,
            program_id: program_id
        })
    }

    showModalProgramSummary = (program_id, is_priced_template, program_name) => {
        this.setState({
            showModalProgramSummary: true,
            isPricedTemplate: is_priced_template,
            programName: program_name,
            program_id: program_id
        })
    }

    handleProgramClick = event => {
        var link = event.currentTarget.getAttribute("href");
        this.props.history.push(link);
        event.preventDefault();
    }

    renderPrograms() {
        var programs  = this.state.program_ids_no_dir;
        var folders;
        var add_new_btn;
        var border_listgroup_bottom = <div style={{width:"100%", borderTop:"1px solid #ccc"}}/>
        var client_name      = this.state.clientName;
        var client_id        = this.state.clientId;
        var tmp_client_id    = 0;
        var tmp_client_name  = 0;
        var new_client_name  = client_name + "'s ";


        if(client_name == "undefined") new_client_name = "";

        var title            = (client_id != "undefined" && client_id != 0 ? (new_client_name + "Programs") : "Templates");
        var btn_add_new_text = "Program"

        if(client_id != "undefined")   tmp_client_id = client_id;
        if(client_name != "undefined") tmp_client_name = client_name;

        var href = "/programs/new/"+tmp_client_id+"/"+tmp_client_name;

        if(client_name != "undefined")
            href = "/client/newProgram/"+tmp_client_id+"/"+tmp_client_name;

        //// TMP HIDE FOLDERS IF LOOKING UP CLIENT PROGRAMS ////
        if(client_id == "undefined") {
            folders     = <PanelGroup className="panelGroupHomePage" style={{position:"relative", cursor: "pointer", top:-21, padding:1, borderRadius: 5, border:"1px solid #ccc"}}>
                              { !this.state.isLoading && this.renderFoldersList(this.state.folders, this.state.program_ids)}
                          </PanelGroup>;

            border_listgroup_bottom;
            btn_add_new_text = "Template"
        }

        add_new_btn =  <span className="pull-right" style={{ position:"relative", top:14}}>
                            <Button className = "btnClientAddNew" href={href}  onClick={this.handleProgramClick}>
                                <span key="new" style={{cursor: "pointer"}}>
                                    Add New { btn_add_new_text }
                                </span>
                            </Button>
                          </span>

        return (
          <div className="programs">
                <PageHeader>
                        <FontAwesomeIcon icon="paste" style={{ position:"relative", top:5, fontSize: '1.6em', color: Colors.primary_color, paddingRight:"16px" }}/>
                        { title }
                        { add_new_btn }
                </PageHeader>
                {/* Listgroup's float:left is required because if it's absent, the progress loading message
                    get's pushed lower on the page since Listgroup isn't registered on a zIndex level   */ }
                <ListGroup style={{width:"100%", float:"left"}}>
                        { /*The program was sent to
                        <span style={{textAlign:"center", cursor:"pointer"}}
                              onClick={(e) => handleGoToURL(e, this, `/programs/list/29f05c50-b2ab-11e8-9392-cdc36ab27e5a/&`)}>
                          Client
                        </span>*/ }

                    {!this.state.isLoading && this.renderProgramsList(client_id, programs)}

                    { border_listgroup_bottom}
                </ListGroup>
                { folders }
                <br/><br/><br/><br/>
          </div>
        );
    }

    render() {
        var global_company_id = this.props.globalCompanyId;
        let closeModalSendProgram  = () => this.setState({ showModalSendProgram: false }); //close simple modal window
        let closeModalCreateFolder = () => this.setState({ showModalCreateFolder: false }); //close simple modal window
        let closeModalMoveProgram  = () => this.setState({ showModalMoveProgram: false }); //close simple modal window
        let closeModalAlert           = () => this.setState({ showModalAlert: false }); //close simple modal window
        let closeModalProgramSummary  = () => this.setState({ showModalProgramSummary: false }); //close simple modal window

        return (
              <div className="ProgramList">
                {this.props.isAuthenticated ? this.renderPrograms() : <RenderLander />}

                    <FooterLoadingBar text                  = {this.state.loadingData}
                                      loadingTime           = {this.state.loadingTime}
                                      newProgramId          = {this.state.newProgramId}
                                      action                = {this.state.footerBarAction}
                                      processCallback       = {this.checkIfNewProgramWasDuped}
                                      showTaskManagerHeader = {this.showTaskManagerHeader}
                                      clearProgressOverlay  = {this.clearProgressOverlay}
                                      showLoadingBar        = {this.state.showLoadingBar}/>

                    {this.state.showModalSendProgram ?
                        <ModalSendProgram
                            show                   = {this.state.showModalSendProgram}
                            isAuthenticated        = {this.props.isAuthenticated}
                            programName            = {this.state.programName}
                            onHide                 = {closeModalSendProgram}
                            programId              = {this.state.program_id}
                            globalCompanyId        = {global_company_id}
                            isPricedTemplate       = {this.state.isPricedTemplate}
                            handleDuplicateProgram = {this.handleDuplicateProgram}
                        />
                    : null}

                    {this.state.showModalAlert ?
                        <ModalAlert
                            onHide         = {closeModalAlert}
                            alertFunction  = {this.alertFunction}     // custom function to call within modal
                            alertAction    = {this.state.alertAction} // flag used for above function
                            alertObject    = {this.state.alertObject} // vars used for above function
                            showModalAlert = {this.state.showModalAlert}
                            messageTitle   = {this.state.modalAlertTitleText}
                            messageBody    = {this.state.modalAlertBodyText}
                        />
                    : null}

                    {this.state.showModalCreateFolder ?
                        <ModalCreateFolder
                            show={this.state.showModalCreateFolder}
                            onHide={closeModalCreateFolder}
                            getProgramList={this.getProgramList}
                        />
                    : null}

                    {this.state.showModalMoveProgram ?
                      <ModalMoveProgramToFolder
                          show={this.state.showModalMoveProgram}
                          onHide={closeModalMoveProgram}
                          program_id={this.state.program_id}
                          getProgramList={this.getProgramList}
                      />
                    : null}

                    {this.state.showModalProgramSummary ?
                      <ModalProgramSummary
                          show             = {this.state.showModalProgramSummary}
                          onHide           = {closeModalProgramSummary}
                          isPricedTemplate = {this.state.isPricedTemplate}
                          programName      = {this.state.programName}
                          program_id       = {this.state.program_id}
                          getProgramList   = {this.getProgramList}
                      />
                    : null}
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/program/ProgramList.js